import fr from 'facet-rest';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import SelectField from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';
import { fullDateISO, monthYear, year } from 'Consts/DateFormats';
import { NumberFormatUsd, PhoneMaskedTextInput } from 'Components/UI/MaskedInput';
import moment from 'moment';
import SensitiveInfoInput from 'Components/ComponentLibrary/Molecules/Inputs/SensitiveInfoInputPicker';
import RichTextEditor from 'Components/UI/RichTextEditor';
import SocialSecurityNumberInput
  from 'Components/ComponentLibrary/Components/Inputs/MaskedInputs/Types/SocialSecurityNumberInput';
import Password from 'Components/ComponentLibrary/Components/Inputs/Password';
import Autocomplete from 'Components/UI/Autocomplete';
import { SearchableSelect } from 'Components/UI/Select/SearchableSelect';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export const BaseOverrideNoHidden = fr.metaOverride()
  .typeOverride('date', {
    _customProps: {
      openTo: 'year',
      inputProps: {
        inputMode: 'decimal',
      },
    },
    _component: () => DateField,
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment.utc(v).format(fullDateISO);
    },
  })
  .override({ hint: 'yearMonth' }, {
    _customProps: {
      openTo: 'year',
      views: ['year', 'month'],
      format: monthYear,
      placeholder: monthYear,
    },
    _component: () => DateField,
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment(v).utc().startOf('month').toISOString();
    },
  })
  .override({ hint: 'years' }, {
    _customProps: {
      openTo: 'year',
      views: ['year'],
      format: year,
      placeholder: year,
    },
    _component: () => DateField,
  })
  .typeOverride('string', { _component: () => TextField })
  .override({ hint: 'phoneNumber' }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: PhoneMaskedTextInput,
      },
    },
  })
  .nameOverride('enabledFor', { _component: Autocomplete }, { ordinal: 50 })
  .nameOverride(['password', 'newPassword', 'currentPassword'], { _component: () => Password })
  .typeOverride('number', {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputMode: 'decimal',
      },
    },
  })
  // This is a temporary fix until global override can override nested objects properly
  .override({ hint: 'usd' }, {
    _customProps: {
      InputProps: {
        inputComponent: NumberFormatUsd,
      },
    },
  })
  .typeOverride('picklist', { _component: () => SelectField })
  .typeOverride('multipicklist', { _component: () => SelectField })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  })
  .override({
    hint: 'ssn-writeonly',
  }, {
    _component: () => SensitiveInfoInput,
    _spreadPropNames: ['resource', 'attrName'],
    _customProps: {
      writeOnly: true,
      mask: '•••-••-••••',
      relationshipName: fr.relationships.sensitiveInfoSocialSecurityNumber.name,
      UnlockedInputComponent: () => SocialSecurityNumberInput,
    },
  })
  .override({ hint: 'richtext' }, { _component: () => RichTextEditor })
  .override({ hint: 'richtext', readonly: true }, { _component: () => Richtext }, overrideReadOnly)
  .override({ hint: 'autocomplete' }, {
    _component: () => SearchableSelect,
  })
  .done();

/**
 * @deprecated - don't use this. Use BaseOverrideNoHidden instead
 */
const BaseOverride = fr.metaOverride({ base: BaseOverrideNoHidden })
  .override({ readonly: true }, { hidden: true })
  .done();

export default BaseOverride;
